import { render, staticRenderFns } from "./SeguimientoCli.vue?vue&type=template&id=70477a4a&lang=pug"
import script from "./SeguimientoCli.vue?vue&type=script&lang=js"
export * from "./SeguimientoCli.vue?vue&type=script&lang=js"
import style0 from "./SeguimientoCli.vue?vue&type=style&index=0&id=70477a4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports